import React from "react";
import { Link } from "react-router-dom";
import { Braces, Code2, Image as ImageIcon } from "lucide-react";

const tools = [
  {
    title: "Compiler",
    body: "Swift code compilation, real-time error detection, and support for 46 languages. AI-assisted debugging when something goes wrong.",
    link: "/compiler",
    icon: Braces,
    image: "/homeImages/1.png",
  },
  {
    title: "Web Editor",
    body: "Edit HTML, CSS, and JS side by side with an instant live preview. No setup, no build step.",
    link: "/web",
    icon: Code2,
    image: "/homeImages/2.png",
  },
  {
    title: "SVG Editor",
    body: "Write or upload SVG markup and see it rendered live. Zoom, pan, rename, and download the result.",
    link: "/svg",
    icon: ImageIcon,
    image: "/homeImages/3.png",
  },
];

const Home = () => {
  return (
    <div className="mx-auto max-w-5xl px-8 py-12 text-vscode-text">
      <h1 className="text-3xl font-light text-vscode-textBright">CodeBase</h1>
      <p className="mt-2 max-w-xl text-sm text-vscode-textMuted">
        Your all-in-one solution for streamlined and efficient programming —
        support for a diverse range of languages, right in the browser.
      </p>

      <section className="mt-10">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-vscode-textMuted">
          Start
        </h2>
        <div className="mt-3 flex flex-col gap-1">
          {tools.map(({ title, link, icon: Icon }) => (
            <Link
              key={link}
              to={link}
              className="flex items-center gap-3 rounded-sm px-2 py-1.5 text-sm text-vscode-accent hover:bg-vscode-listHover hover:underline"
            >
              <Icon size={16} strokeWidth={1.75} />
              Open {title}
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-10">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-vscode-textMuted">
          Walkthroughs
        </h2>
        <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {tools.map(({ title, body, link, image }) => (
            <Link
              key={link}
              to={link}
              className="group flex flex-col overflow-hidden rounded-sm border border-vscode-border bg-vscode-panel transition-colors hover:border-vscode-accent"
            >
              <img
                src={image}
                alt={`${title} screenshot`}
                className="h-32 w-full border-b border-vscode-border object-cover object-top opacity-90 transition-opacity group-hover:opacity-100"
              />
              <div className="flex flex-1 flex-col gap-1 p-3">
                <h3 className="text-sm font-medium text-vscode-textBright">
                  {title}
                </h3>
                <p className="text-xs text-vscode-textMuted">{body}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-10 border-t border-vscode-border pt-6">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-vscode-textMuted">
          Help
        </h2>
        <div className="mt-3 flex items-center gap-4 text-sm">
          <span className="text-vscode-textMuted">
            Made by Arinaymay Bhaskar
          </span>
          <a
            href="https://github.com/Arinaymaybhaskar"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-vscode-accent hover:underline"
          >
            <img src="/github.svg" alt="" className="h-4 w-4 invert" />
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/arinaymay/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-vscode-accent hover:underline"
          >
            <img src="/linkedin.svg" alt="" className="h-4 w-4 invert" />
            LinkedIn
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
